import { DesktopShell } from '@/components/dashboard/DashboardShell';
import { AcademicCalendarContent } from '@/components/dashboard/AcademicCalendarContent';

export default function AcademicCalendarDesktop() {
  return <AcademicCalendarContent Shell={DesktopShell} mode="desktop" />;
}
